import "./PgpKeysView.scss";
import {StackPanel} from "../panels/StackPanel";
import React from "react";
import {PgpKeyListView} from "./PgpKeyListView";
import {AppContainer} from "../common/AppContainer";
import {ContentViewContainer} from "../ContentView";
import {useAppSelector} from "../../hooks/ReduxHooks";
import {hasItemContent} from "../../domain/ItemContent";
import {getItemContent} from "../../state/ItemState";

export const PgpKeysView = () => {

    const hasContent = useAppSelector(({itemState}) => hasItemContent(getItemContent(itemState)));

    return (
        <AppContainer contentClassName="main-content pgp-keys-view">
            <ContentViewContainer hasContent={hasContent}
                                  itemsListElement={<StackPanel orientation="vertical"
                                                                align="stretch"
                                                                fill={true}
                                                                className="left-panel content-item-list">
                                      <PgpKeyListView/>
                                  </StackPanel>}
            />
        </AppContainer>
    );
}
